import {defineMessages} from "react-intl";

export const EMAIL_REXEP_VALIDATION = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/;

export const ADD_PAYOUT_METHOD_TEXT = defineMessages({
  'directDepositTextOne': {
    id: 'AddPayoutMethod.direct.deposit.description.text.one',
    defaultMessage: "To receive direct deposit payments, you'll need to provide your bank details in your profile after creating a listing."
  },
  'directDepositTextTwo': {
    id: 'AddPayoutMethod.direct.deposit.description.text.two',
    defaultMessage: "You'll be paid in the currency you listed your tickets in.  Make sure your bank account can accept this currency. "
  }
});

export const PayoutMethods = Object.freeze({
  PAY_PAL: "PayPal",
  DIRECT_DEPOSIT: "ACH",
  EMPTY: ""
});

export const PayoutMethodsRatio = Object.freeze({
  PAY_PAL: "payout-methods-paypal",
  DIRECT_DEPOSIT: "payout-methods-direct-deposit"
});

export const PayPalStatus = Object.freeze({
  NEW: "NEW",
  UPDATED: "UPDATED",
  UNTOUCHED: "UNTOUCHED",
  ERROR: "ERROR"
});

